import { render } from "./MyHeaderPage.vue?vue&type=template&id=8c940cce"
import script from "./MyHeaderPage.vue?vue&type=script&lang=js"
export * from "./MyHeaderPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__